export default __webpack_public_path__ + "static/sac.range-c030fa343e3ffa5864dd0a05330d26e7.jpg";